import React from 'react';
import { Provider } from "react-redux";
import configure from "../../store/configure";
import Layout from "../../component/layout/Layout";
import FormCreateContainer from "./container/FormCreateContainer";

const FormCreatePage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <FormCreateContainer />
            </Layout>
        </Provider>
    );
};

export default FormCreatePage;
